import { InputAdornment, MenuItem, TextField } from "@mui/material";
import React, { useEffect } from "react";

import PersonIcon from "@mui/icons-material/Person";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";

export const TextFieldCliente = ({ array, onDatosFacturacion, idequip }) => {
  useEffect(() => {
    if (array !== undefined && array !== null & array.length === 1 ) {
      onDatosFacturacion("idequip", array[0].idequip, null, null);
    }
  }, [array]);
  if (array === undefined || array === null || array.length === 0)
    return (
      <TextField
        fullWidth
        size="small"
        label="CLIENTE EN EQUIP"
        className="cel4"
        type="text"
        onChange={({ target }) => {
          ValOnlyNumber("idequip", target.value, onDatosFacturacion, true, 8);
        }}
        value={idequip}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon />
            </InputAdornment>
          ),
        }}
      />
    );

  if (array.length === 1)
    return (
      <TextField
        disabled={true}
        fullWidth
        size="small"
        label="CLIENTE EN EQUIP"
        className="cel4"
        type="text"
        onChange={({ target }) => {
          ValOnlyNumber("idequip", target.value, onDatosFacturacion, true, 10);
        }}
        value={idequip}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon />
            </InputAdornment>
          ),
        }}
      />
    );

  return (
    <TextField
      fullWidth
      size="small"
      label="CLIENTE EN EQUIP"
      className="cel4"
      type="text"
      onChange={({ target }) => {
        ValOnlyNumber("idequip", target.value, onDatosFacturacion, true, 10);
      }}
      value={idequip}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PersonIcon />
          </InputAdornment>
        ),
      }}
      select
    >
      {array.map((item) => (
        <MenuItem value={item.idequip}>{item.idequip}</MenuItem>
      ))}
    </TextField>
  );
};
